import * as React from "react";
import { Route, Routes } from "react-router";
import { AuthLayout } from "@/views/auth/layout";
import { LoginView } from "@/views/auth/login";
import { ResetPasswordView } from "@/views/auth/reset-password";
import { ResetPasswordSetNewView } from "@/views/auth/reset-password-set-new";
import { RootLayout } from "@/layouts/root-layout";
import { HomeView } from "@/views/home";
import { UsersView } from "@/views/admin/users/page";
import { BusinessReportsView } from "@/modules/snapshots";
import { BusinessReportGenerateView } from "@/modules/snapshots/generate";
import { BusinessReportOutcomeDetailsView } from "@/modules/snapshots/outcome-details";
import { RootDriveView } from "@/views/drive/page";
import { SubfolderDriveView } from "@/views/drive/details";
import { ChatView } from "@/views/chat";
import { SharedView } from "@/views/shared";
import { CalendarView } from "@/views/home/calendars";
import { DeadlineGuardianView } from "@/views/home/deadline_guardian";
import { SessionExpiredView } from "@/views/auth/session-expired";
import TopBarProgress from "react-topbar-progress-indicator";
import { SharepointView } from "@/views/sharepoint";
import { OpenChatView } from "@/views/open-chat";
import { OpenChatWithParamsView } from "@/views/open-chat/index-with-params";
import { ChronologyView } from "@/views/chronology";
import { ChronologyListView } from "@/views/chronology-list";
import { PromptLibraryView } from "@/modules/promptLibrary/components/promptLibraryView";
import { MyCalendarView } from "@/modules/myCalendar/MyCalendarView";

TopBarProgress?.config({
  barThickness: 7,
  barColors: { "0": "rgba(198, 174, 126, 1)", "1.0": "rgba(148, 118, 72, 1)" },
  shadowBlur: 5,
});

export const App: React.FC = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path="/session-expired" element={<SessionExpiredView />} />
      <Route path="login" element={<LoginView />} />
      <Route path="reset-password" element={<ResetPasswordView />} />
      <Route path="reset-password/:token" element={<ResetPasswordSetNewView />} />
    </Route>
    <Route element={<RootLayout />}>
      <Route index={true} element={<HomeView />} />
      <Route path="admin/users" element={<UsersView />} />
      <Route path="calendars" element={<CalendarView />} />
      <Route path="drive" element={<RootDriveView />} />
      <Route path="shared" element={<SharedView />} />
      <Route path="my-calendar" element={<MyCalendarView />} />
      <Route path="sharepoint" element={<SharepointView />} />
      <Route path="sharepoint/*" element={<SharepointView />} />
      <Route path="deadline_guardian/:matterId" element={<DeadlineGuardianView />} />
      <Route path="drive/:fseId" element={<SubfolderDriveView />} />
      <Route path="chat/:systemId" element={<ChatView />} />
      <Route path="chronology-list" element={<ChronologyListView />} />
      <Route path="open-chat" element={<OpenChatView />} />
      <Route path="open-chat/:conversationId" element={<OpenChatWithParamsView />} />
      <Route path="reports" element={<BusinessReportsView />} />
      <Route path="snapshots" element={<BusinessReportsView />} />
      <Route path="snapshots/:tab" element={<BusinessReportsView />} />
      <Route path="reports/:fseId" element={<BusinessReportGenerateView />} />
      <Route path="reports/outcome/:outcomeId" element={<BusinessReportOutcomeDetailsView />} />
      <Route path="prompt-library" element={<PromptLibraryView />} />
      <Route path="chronology/:systemId" element={<ChronologyView />} />
      <Route path="chronology/:systemId/:fseId" element={<ChronologyView />} />
    </Route>
  </Routes>
);
